import { render, staticRenderFns } from "./ProjectListDeatil.vue?vue&type=template&id=0af17c5a&scoped=true"
import script from "./ProjectListDeatil.vue?vue&type=script&lang=js"
export * from "./ProjectListDeatil.vue?vue&type=script&lang=js"
import style0 from "./ProjectListDeatil.vue?vue&type=style&index=0&id=0af17c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af17c5a",
  null
  
)

export default component.exports